<template>
  <el-checkbox v-model="value" @update:modelValue="input">
    Block nocookie traffic
    <IconWithHint>
      Traffic without IP or user agent<br />
      (if we cannot detect it for some reason)
    </IconWithHint>
  </el-checkbox>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import IconWithHint from '@/components/IconWithHint.vue'

export default defineComponent({
  name: 'BlockNoCookies',
  components: {
    IconWithHint
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    function input(newValue: boolean) {
      context.emit('update:modelValue', newValue)
    }

    return { input, value }
  }
})
</script>
